import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
import Box from 'core/ui/Box';
import { secondaryBgLight } from 'core/ui/Colors';
import { DialogActions, DialogContent } from '@material-ui/core';
import TimePickerRounded from 'core/ui/DatePickers/TimePickerRounded';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import { ButtonPrimary } from 'core/ui/Button';
import { date, formatDateApi } from 'core/utils/formatters';
import { cutTime } from 'core/utils/formatters/date';
import { competitionsSelectors } from 'modules/competitions';
import { useSelector } from 'react-redux';

const ModalEditHeat = ({ open, heat, close, changeHeat, createNewHeat }) => {
  const [data, setData] = useState({});
  const { t } = useTranslation();
  const competition = useSelector((state) => competitionsSelectors.getCompetition(state));

  const saveHeat = () => {
    const formData = {};
    if (data.startTime) {
      formData.startTime = cutTime(data.startTime);
    }

    if (data.name) {
      formData.name = data.name;
    }
    if (data.lanes) {
      formData.lanes = data.lanes;
    }

    if (heat?.id) {
      changeHeat(heat?.id, formData);
    } else {
      createNewHeat(formData);
    }
  };

  useEffect(() => {
    const baseDate = date(new Date(), 'DD-MM-YYYY');

    setData((prev) => ({
      ...prev,
      lanes: heat?.lanes,
      name: heat?.name,
      startTime:
        heat?.startTime &&
        formatDateApi(`${baseDate} ${heat.startTime}`, 'YYYY-MM-DD HH:mm:ss a Z'),
    }));
  }, [heat]);

  return (
    <Dialog style={{ marginTop: 100 }} open={!!open} onClose={close}>
      <DialogContent style={{ backgroundColor: secondaryBgLight }}>
        <Box mb={4}>
          <TextFieldRounded
            label="Heat Name"
            value={data?.name}
            onChange={(v) => setData((prev) => ({ ...prev, name: v }))}
          />
        </Box>

        <Box mb={4}>
          <TextFieldRounded
            label={t('workout.heat.lanes')}
            value={data?.lanes}
            onChange={(v) => setData((prev) => ({ ...prev, lanes: v }))}
          />
        </Box>

        <Box>
          <TimePickerRounded
            name="scheduledAt"
            type="datetime-local"
            onChange={(v) => {
              setData((prev) => ({ ...prev, startTime: v }));
            }}
            value={data?.startTime}
            required
            autoOk={false}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <ButtonPrimary buttonColor={competition?.buttonColor} onClick={() => saveHeat()}>
          {t('button.save')}
        </ButtonPrimary>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEditHeat;
